import { render, staticRenderFns } from "./NewTopBar.vue?vue&type=template&id=0b1afc52&scoped=true&"
import script from "./NewTopBar.vue?vue&type=script&lang=js&"
export * from "./NewTopBar.vue?vue&type=script&lang=js&"
import style0 from "./NewTopBar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewTopBar.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./NewTopBar.vue?vue&type=style&index=2&id=0b1afc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1afc52",
  null
  
)

export default component.exports